// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  graveId: __t.u64().primaryKey().name("grave_id"),
  worldId: __t.u64().name("world_id"),
  settlementId: __t.u64().name("settlement_id"),
  versonaId: __t.u64().name("versona_id"),
  name: __t.string(),
  cause: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  epitaph: __t.string(),
  diedAt: __t.timestamp().name("died_at"),
});
